import { render, staticRenderFns } from "./GradeCard.vue?vue&type=template&id=93080b26&scoped=true&"
import script from "./GradeCard.vue?vue&type=script&lang=js&"
export * from "./GradeCard.vue?vue&type=script&lang=js&"
import style0 from "./GradeCard.vue?vue&type=style&index=0&id=93080b26&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93080b26",
  null
  
)

export default component.exports